import React from "react";
import { Alert, AlertTitle } from "@material-ui/lab";
import { css } from "@emotion/css";
import { CatalogueGap, CatalogueGapField } from "routes/createContent/api/catalogueDeployments";

const fieldLabel = (field: CatalogueGapField) => {
  switch (field) {
    case "translation":
      return "no translation";
    case "title":
      return "no title";
    case "image":
      return "image missing";
    case "video":
      return "video missing";
    case "caption":
      return "captions missing";
    case "content":
      return "no content";
  }
};

const placeLabel = (gap: CatalogueGap) => {
  if (gap.level !== undefined) return `Level ${gap.level}`;
  if (gap.part !== undefined) return `Part ${gap.part}`;
  return "";
};

const byPlace = (gaps: CatalogueGap[]) =>
  gaps.reduce<Map<string, CatalogueGap[]>>(
    (places, gap) => places.set(placeLabel(gap), [...(places.get(placeLabel(gap)) ?? []), gap]),
    new Map()
  );

export const CatalogueGaps: React.VFC<{ gaps: CatalogueGap[] | undefined }> = ({ gaps }) => {
  if (!gaps?.length) {
    return null;
  }

  return (
    <Alert severity="warning" className={styles.alert}>
      <AlertTitle>Can&apos;t deploy to prod until these are filled</AlertTitle>
      <ul className={styles.list}>
        {Array.from(byPlace(gaps)).map(([place, placeGaps]) => (
          <li key={place}>
            {place && <strong>{place}: </strong>}
            {placeGaps.map(gap => `${gap.locale} ${fieldLabel(gap.field)}`).join(", ")}
          </li>
        ))}
      </ul>
    </Alert>
  );
};

const styles = {
  alert: css`
    margin: 8px 0;
  `,
  list: css`
    margin: 0;
    padding-left: 20px;
  `,
};
